import React from "react";
import { connect } from "react-redux";
import { Col, Row } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { getBillingPaymentDetails } from "../../../actions/BillingActions";
import moment from "moment";
import { useHistory, Link } from "react-router-dom";
import { Close } from "@material-ui/icons";

function UserBillingPlanDetails({ getBillingPaymentDetails }) {
  const history = useHistory();
  const today = moment();
  const [paymentDetails, setPaymentDetails] = React.useState({});

  React.useEffect(() => {
    if (history.location.state === undefined) {
      // history.push({
      //   pathname: "/BillingModule/BillingPaymentDetails",
      // });
      getPaymentDetails(today.format("YYYYMM"));
    } else {
      getPaymentDetails(history.location.state.invoicePeriod);
    }
  }, []);

  function getPaymentDetails(invoicePeriod) {
    let ownerId = "";
    let usertype = localStorage.getItem("usertype");
    if (usertype === "VENDOR") {
      ownerId = localStorage.getItem("ownerId");
    } else {
      ownerId = localStorage.getItem("ID");
    }

    let data = {
      userId: ownerId,
      invoicePeriod: invoicePeriod,
    };
    getBillingPaymentDetails(data)
      .then((res) => {
        // console.log("here getBillingPaymentDetails", res);

        setPaymentDetails(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    return paymentDetails;
  }

  return (
    <>
      <div className="step-progress transaction-create">
        <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
          <Col xs={12} sm={3}>
            <h4 className="title-med mt-0 pt-1">Billing Plan Details</h4>
          </Col>
          {history.location.state !== undefined && (
            <>
              <Col xs={12} sm={6} />

              <Col xs={12} sm={3} align="right" className="transaction-close">
                <Link
                  to="/BillingModule/BillingPaymentDetails"
                  className="nav-link p-0 color-black"
                >
                  <Close
                    style={{ stroke: "#fff", height: "40px", width: "40px" }}
                  />
                </Link>
              </Col>
            </>
          )}
        </Row>
        <div
          className="admin-steps admin-content-area"
          style={{ paddingTop: 20 }}
        >
          <div className="container-custom">
            <Row>
              <Col xs={12} sm={6}>
                <h5 className="font-16 color-blue-4 font-600">Plan Info</h5>
                <div className="color-grey-1 font-14">Plan Name</div>
                <h4 className="font-20 color-blue-4 font-600">
                  {paymentDetails && paymentDetails.PlanName
                    ? paymentDetails.PlanName
                    : ""}
                </h4>
                <Row>
                  <Col xs={12} sm={6}>
                    Plan Start Date
                  </Col>
                  <Col xs={12} sm={6}>
                    {paymentDetails && paymentDetails.currentPlanStartDate
                      ? moment(paymentDetails.currentPlanStartDate).format(
                          "Do MMM YYYY"
                        )
                      : ""}
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={6}>
                    Plan End Date
                  </Col>
                  <Col xs={12} sm={6}>
                    {paymentDetails && paymentDetails.currentPlanEndDate
                      ? moment(paymentDetails.currentPlanEndDate).format(
                          "Do MMM YYYY"
                        )
                      : ""}
                  </Col>
                </Row>
              </Col>
              <Col xs={12} sm={5}>
                <h5 className="font-16 color-blue-4 font-600">Plan Details</h5>
                <Row>
                  <Table
                    className="add-buyer-table update-render"
                    style={{ textAlign: "right" }}
                  >
                    <thead>
                      <tr>
                        <th style={{ textAlign: "left" }}>Reference</th>
                        <th>Free</th>
                        <th>Charge</th>
                        <th>
                          {" "}
                          <span>&nbsp;</span>{" "}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {paymentDetails &&
                        paymentDetails.billingItems &&
                        paymentDetails.billingItems.length > 0 &&
                        paymentDetails.billingItems.map((item, index) => {
                          return (
                            <>
                              <tr key={index}>
                                <td style={{ textAlign: "left" }}>
                                  {item.billingItemDesc}
                                </td>
                                <td>{item.freeCount}</td>
                                <td>${item.perCharge.toFixed(2)}</td>
                                <td>
                                  {" "}
                                  <span>&nbsp;</span>{" "}
                                </td>
                              </tr>
                            </>
                          );
                        })}
                    </tbody>
                  </Table>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {
    getBillingPaymentDetails,
  }
)(UserBillingPlanDetails);
